_ = require("lodash")
moment = require("moment")

AnalysisService = ($http, $q, ScoreCardAPIService, $routeParams, cache) ->
  id = $routeParams.user_id
  if ($routeParams.user_id == undefined)
    id =  "me"

  getScoreCards: ->
    $http.get("/api/users/#{id}/score_cards.json")

  getMyAnalysis: (options={}) ->
    params = _.pickBy
      from: (options.from.utc().toISOString() if options.from)
      to: (options.to.utc().toISOString() if options.to)
      course_id: options.course?.ext_id
      round_type: options.round_type?.join(',')
    , (v) -> v != null && v != undefined

    cacheParams = JSON.stringify(params)
    cachedMyAnalysis = cache.get(cacheParams)
    defer = $q.defer()
    if cachedMyAnalysis
      defer.resolve cachedMyAnalysis
    else
      promises =
        best_worst: ScoreCardAPIService.getBestWorst(id,params)
        my_avg: ScoreCardAPIService.getMyAvg(id,params)

      $q.all(promises).then (result) ->
        myAnalysis =
          my_avg: result.my_avg.data
          best_score: result.best_worst.data.best_score
          worst_score: result.best_worst.data.worst_score
        cache.put(cacheParams, myAnalysis)
        defer.resolve myAnalysis

    defer.promise

  convertScoreCards: (scorecards, options={}) ->
    _.defaults options,
      endDate: moment()
      startDate: moment().subtract(1, 'years')

    filteredByTime = _.chain(scorecards)
      .map (sc) ->
        _.merge {}, sc,
          play_date: moment(sc.play_date)
      .filter (sc) ->
        options.startDate <= sc.play_date <= options.endDate.endOf('day')

    filterByRoundType = filteredByTime
      .filter (sc) ->
        return true unless options.roundType
        sc.round_type in options.roundType

    #Group for clubs
    clubs = filterByRoundType
      .groupBy (sc) ->
        "#{sc.club.ext_type}-#{sc.club.ext_id}"
      .map (score_cards, key) ->
        sc = score_cards[0]
        id: key
        loc: sc.club.loc
        count: score_cards.length
      .value()

    #Group for courses
    courses = filterByRoundType
      .groupBy (sc) ->
        "#{sc.club.ext_type}-#{sc.club.ext_id}-#{sc.course.ext_id}"
      .map (score_cards, key) ->
        sc = score_cards[0]
        id: key
        club: sc.club
        course: sc.course
        count: score_cards.length
      .sortBy (course) -> -course.count
      .value()

    #Filter TimeSeries
    #- For the case user selected a course but the filteredByTimeData do not contain this course
    #- So That we need to take all
    hasSelectedCourse = filterByRoundType
      .some (sc) ->
        return false unless options.course
        sc.course.ext_id is options.course.course.ext_id
      .value()

    filteredScorecards = filterByRoundType
      .filter (sc) ->
        return true unless options.course
        return true unless hasSelectedCourse
        sc.course.ext_id is options.course.course.ext_id
      .sortBy (sc) -> sc.play_date
      .map (sc) ->
        _.pick sc, 'id', 'play_date', 'total_shot_all_holes', 'total_putt_all_holes', 'course', 'club', 'round_type'
      .value()

    clubs: clubs
    courses:  courses
    filteredScorecards: filteredScorecards

AnalysisService.$inject = [
  '$http'
  '$q'
  'ScoreCardAPIService'
  '$routeParams'
  'cache'
]

module.exports = AnalysisService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/analysis/analysis-service.coffee